import { useState, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search } from 'lucide-react';

interface SearchBarProps {
  large?: boolean;
  initialValue?: string;
  onSearch?: (query: string) => void;
  placeholder?: string;
}

export function SearchBar({
  large = false,
  initialValue = '',
  onSearch,
  placeholder = 'Search Arches and Entities...',
}: SearchBarProps) {
  const [query, setQuery] = useState(initialValue);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();

      if (onSearch) {
        onSearch(query);
      } else {
        // Navigate to browse page with search query
        const params = new URLSearchParams(searchParams);
        if (query.trim()) {
          params.set('q', query.trim());
        } else {
          params.delete('q');
        }
        navigate(`/marketplace/browse?${params.toString()}`);
      }
    },
    [query, onSearch, navigate, searchParams],
  );

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="relative flex gap-2">
        <Input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={placeholder}
          className={large ? 'h-14 text-lg px-5' : ''}
        />
        <Button type="submit" size={large ? 'lg' : 'default'}>
          <Search className="h-4 w-4 mr-2" />
          Search
        </Button>
      </div>
    </form>
  );
}
